import React from 'react';
import { StyleSheet, View } from 'react-native';
import Icon, { IconKeyType } from 'shared/components/vxl/icon/Icon/Icon';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import theme from 'shared/styles/theme';

interface IconBulletListProps {
  text: string;
  icon: IconKeyType;
}

const IconBulletList = ({ text, icon }: IconBulletListProps) => {
  return (
    <View style={styles.itemContainer}>
      <Icon iconKey={icon} iconSize="MD" />
      <BodySmText style={styles.itemText} numberOfLines={0}>
        {text}
      </BodySmText>
    </View>
  );
};

const styles = StyleSheet.create({
  itemContainer: {
    flexDirection: 'row',
  },
  itemText: {
    flexShrink: 1,
    marginLeft: theme.spacing.s,
  },
});

export default IconBulletList;
